import { MouseEventHandler } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { mayaCepListRoute } from 'basics/constants/routes.constants';
import { CepSteps } from 'basics/enums/maya.enums';
import { StepButtonsConfig } from 'components/ButtonsBar/ButtonsBar';
import { UseStepIndexer } from 'hooks/useStepIndexer';
import { CepViewStepsIndex } from 'routes/AuthenticatedApp/CepView/CepView.types';
import { ButtonType } from 'yoda-ui/components/Button/Button.types';
import { Icons } from 'yoda-ui/components/Icons/Icon';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useCepViewButtons = (
  stepIndexer: UseStepIndexer,
  nextPage: MouseEventHandler,
  previousPage: MouseEventHandler,
) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const firstStepButtons: StepButtonsConfig = {
    thirdButton: {
      buttonProps: {
        onClick: nextPage,
        buttonType: ButtonType.primary,
      },
      label: t('actions_next_label'),
    },
  };

  const middleStepsButtons: StepButtonsConfig = {
    firstButton: {
      buttonProps: {
        onClick: previousPage,
        buttonType: ButtonType.primary,
        startIconName: Icons.arrowBack,
      },
      label: t('actions_previous_label'),
      hidden: false,
    },
    thirdButton: {
      buttonProps: {
        onClick: nextPage,
        buttonType: ButtonType.primary,
      },
      label: t('actions_next_label'),
    },
  };

  const lastStepButtons: StepButtonsConfig = {
    firstButton: {
      buttonProps: {
        onClick: previousPage,
        buttonType: ButtonType.primary,
        startIconName: Icons.arrowBack,
      },
      label: t('actions_previous_label'),
    },
    thirdButton: {
      buttonProps: {
        onClick: () => navigate(mayaCepListRoute),
        buttonType: ButtonType.primary,
      },
      label: t('maya_cep_view_home'),
    },
  };

  switch (CepViewStepsIndex[stepIndexer.stepIndex]) {
    case CepSteps.configurationStep:
      return firstStepButtons;
    case CepSteps.goalStep:
    case CepSteps.targetListStep:
      return middleStepsButtons;
    case CepSteps.tacticsStep:
      return middleStepsButtons;
    case CepSteps.miViewPreviewStep:
      return lastStepButtons;
    default:
      return null;
  }
};

export default useCepViewButtons;
